<script lang="ts">
	import { goto } from '$app/navigation';
	import type { ChartSelectorOptions } from '$lib/types/home';
	import { chartSelected } from './store';
	export let heading: string;
	export let selection: ChartSelectorOptions;
	function changeSelection() {
		chartSelected.set(selection);
	}
</script>

{#if $chartSelected === selection}
	<div
		class="text-fx-grey-100 bg-fx-grey-800 py-1 px-2 rounded-lg font-medium cursor-pointer text-sm"
	>
		{heading}
	</div>
{:else}
	<div
		class="text-fx-grey-400 py-1 px-2 rounded-lg font-medium cursor-pointer text-sm"
		on:click={changeSelection}
		on:keydown={changeSelection}
	>
		{heading}
	</div>
{/if}
